(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react-native"));
	else if(typeof define === 'function' && define.amd)
		define(["react-native"], factory);
	else if(typeof exports === 'object')
		exports["lib"] = factory(require("react-native"));
	else
		root["lib"] = factory(root["react-native"]);
})(self, (__WEBPACK_EXTERNAL_MODULE__9925__) => {
return 